export enum ButtonVariant {
  Primary = 'contained',
  Secondary = 'outlined',
  Text = 'text'
}
